
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./CryptoBottomNav.css";

const navItems = [
  {
    label: "Market Trader",
    shortLabel: "Market",
    icon: "📊",
    path: "/trader",
  },
  {
    label: "Order",
    shortLabel: "Order",
    icon: "📝",
    path: "/trade",
  },
  {
    label: "Volume",
    shortLabel: "Volume",
    icon: "📈",
    path: "/volume",
  },
  {
    label: "Signal",
    shortLabel: "Signal",
    icon: "⚡",
    path: "/",
  },
];

const hiddenRoutes = [
  "/login",
  "/register",
  "/forgot-password",
];

export default function CryptoBottomNav() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Ficha kwenye login pages tu; ionekane pia kwenye chart.
  const isHidden = hiddenRoutes.includes(currentPath);

  if (isHidden) return null;

  return (
    <nav className="crypto-bottom-nav" aria-label="Main navigation">
      {navItems.map((item) => {
        const isActive =
          item.path === "/"
            ? currentPath === "/" ||
              currentPath.startsWith("/chart/")
            : currentPath === item.path ||
              currentPath.startsWith(`${item.path}/`);

        return (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/"}
            className={`crypto-nav-item ${
              isActive ? "active" : ""
            }`}
            aria-label={item.label}
          >
            <span className="crypto-nav-icon" aria-hidden="true">
              {item.icon}
            </span>

            <span className="crypto-nav-label">
              {item.shortLabel}
            </span>
          </NavLink>
        );
      })}
    </nav>
  );
}
